import React from 'react';
import PropTypes from 'prop-types';
import { Question } from '../../components';

const AssessmentQuiz = props => {
  const { page, goToPrevious, goToNext, onAnswerClicked } = props;
  return (
    <form onSubmit={e => handleSubmit(e, goToNext)}>
      <section className="theme-dark quiz-header">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1>GDPR Readiness Test</h1>
              <span className="subtitle">STEP {page} OF 4</span>
            </div>
          </div>
        </div>
      </section>
      {getPage(page, onAnswerClicked)}
      <section className="quiz-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <a className="btn btn-lg btn-success" onClick={() => goToPrevious()}>
                Previous step
              </a>&nbsp;
              <button className="btn btn-lg btn-success">Next step</button>
            </div>
          </div>
        </div>
      </section>
    </form>
  );
};

AssessmentQuiz.propTypes = {
  page: PropTypes.number.isRequired,
  goToPrevious: PropTypes.func.isRequired,
  goToNext: PropTypes.func.isRequired,
  onAnswerClicked: PropTypes.func.isRequired
};

AssessmentQuiz.defaultProps = {};

export default AssessmentQuiz;

function getPage(page, onAnswerClicked) {
  switch (page) {
    case 1:
      return (
        <section className="quiz-content">
          <Question number={1} onAnswerClicked={onAnswerClicked} />
          <Question number={2} onAnswerClicked={onAnswerClicked} />
          <Question number={3} onAnswerClicked={onAnswerClicked} />
          <Question number={4} onAnswerClicked={onAnswerClicked} />
          <Question number={5} onAnswerClicked={onAnswerClicked} />
          <Question number={6} onAnswerClicked={onAnswerClicked} />
          <Question number={7} onAnswerClicked={onAnswerClicked} />
        </section>
      );
    case 2:
      return (
        <section className="quiz-content">
          <Question number={8} onAnswerClicked={onAnswerClicked} />
          <Question number={9} onAnswerClicked={onAnswerClicked} />
          <Question number={10} onAnswerClicked={onAnswerClicked} />
          <Question number={11} onAnswerClicked={onAnswerClicked} />
          <Question number={12} onAnswerClicked={onAnswerClicked} />
          <Question number={13} onAnswerClicked={onAnswerClicked} />
          <Question number={14} onAnswerClicked={onAnswerClicked} />
        </section>
      );
    case 3:
      return (
        <section className="quiz-content">
          <Question number={15} onAnswerClicked={onAnswerClicked} />
          <Question number={16} onAnswerClicked={onAnswerClicked} />
          <Question number={17} onAnswerClicked={onAnswerClicked} />
          <Question number={18} onAnswerClicked={onAnswerClicked} />
          <Question number={19} onAnswerClicked={onAnswerClicked} />
          <Question number={20} onAnswerClicked={onAnswerClicked} />
          <Question number={21} onAnswerClicked={onAnswerClicked} />
        </section>
      );
    case 4:
      return (
        <section className="quiz-content">
          <Question number={22} onAnswerClicked={onAnswerClicked} />
          <Question number={23} onAnswerClicked={onAnswerClicked} />
          <Question number={24} onAnswerClicked={onAnswerClicked} />
          <Question number={25} onAnswerClicked={onAnswerClicked} />
          <Question number={26} onAnswerClicked={onAnswerClicked} />
        </section>
      );
    default:
      return null;
  }
}

function handleSubmit(event, action) {
  action();
  event.preventDefault();
}



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/AssessmentQuiz/AssessmentQuiz.js